import FGField from './FGField';

type TFGDropdownProps = JSX.IntrinsicElements["select"] & {
  label: string|JSX.Element|JSX.Element[];
  desc?: string|JSX.Element|JSX.Element[];
  options: { value: string; label: string }[];
  defaultValue?: string|number;
  disabled?: boolean;
  onChange: (value: string) => void;
};

export default function FGDropdown(props: TFGDropdownProps) {
  return <FGField name={props.name} label={props.label} desc={props.desc} required={props.required} comp="FGDropdown">
    <select
      id={props.name}
      {...props}
    >
      {props.options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  </FGField>;
}
